import { render } from "./Home.vue?vue&type=template&id=9fd4f31e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/home/nata/programming/WebProjects/DjangoVueEcommerce/djackets_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__